import { createSlice, configureStore } from "@reduxjs/toolkit";

import { AccountModel } from "../../domain/models";
import {
  getCurrentAccountAdapter,
  getCurrentWarehouseAdapter,
  setCurrentAccountAdapter,
  setCurrentWarehouseAdapter,
} from "../../main/adapters";

type authState = {
  getCurrentAccount: () => AccountModel;
  getCurrentWarehouse: () => { id: number; name: string };
  setCurrentAccount: (account: AccountModel | undefined) => void;
  setCurrentWarehouse: (warehouse: { id: number; name: string }) => void;
};

const initialState: authState = {
  getCurrentAccount: getCurrentAccountAdapter,
  getCurrentWarehouse: getCurrentWarehouseAdapter,
  setCurrentAccount: setCurrentAccountAdapter,
  setCurrentWarehouse: setCurrentWarehouseAdapter,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
});

export const store = configureStore({
  reducer: authSlice.reducer,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const authActions = authSlice.actions;
